__webpack_require__.p = "https://www.werther.ch/";